import { render, staticRenderFns } from "./ReceivingPartners.vue?vue&type=template&id=26ef5640"
import script from "./ReceivingPartners.vue?vue&type=script&lang=js"
export * from "./ReceivingPartners.vue?vue&type=script&lang=js"
import style0 from "./ReceivingPartners.vue?vue&type=style&index=0&id=26ef5640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports